import React, { useState, useEffect } from 'react';
import Logo from '../../components/common/Logo';
import { Calendar } from 'lucide-react';
import DoctorSidebar from '../../components/doctor/DoctorSidebar';
import AppointmentService from '../../services/appoinment.service';
import { useNavigate } from 'react-router-dom';
import { formatDate, formatTime, getDaysRemaining, getAppointmentDateTime } from '../../utils/dateUtils';

const DoctorDashboad = () => {
  const navigate = useNavigate();
  const [upcomingAppointments, setUpcomingAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadAppointments();
  }, []);

  const loadAppointments = async () => {
    try {
      setLoading(true);
      const response = await AppointmentService.getDoctorAppointments();
      
      // Assicurati che i dati siano un array
      const appointmentsArray = Array.isArray(response) ? response : (Array.isArray(response.data) ? response.data : []);
      
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const upcoming = appointmentsArray
        .filter(app => {
          const daysRemaining = getDaysRemaining(app.date);
          return daysRemaining >= 0 && app.status != 'cancelled'; // Mostra tutti gli appuntamenti futuri esclusi i cancellati
        })
        .sort((a, b) => {
          // Usa la nuova funzione di ordinamento
          const dateTimeA = getAppointmentDateTime(a);
          const dateTimeB = getAppointmentDateTime(b);
          return dateTimeA.getTime() - dateTimeB.getTime();
        })
        .slice(0, 5); // Prendi solo i prossimi 5 appuntamenti
      
      setUpcomingAppointments(upcoming);
      setError(null);
    } catch (err) {
      console.error('Errore nel caricamento degli appuntamenti:', err);
      setError('Non è stato possibile caricare gli appuntamenti.');
    } finally {
      setLoading(false);
    }
  };

  // ⭐ RIMUOVI LE VECCHIE FUNZIONI formatDate e formatTime - ORA SONO IMPORTATE!

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        <DoctorSidebar />
      </div>

      {/* Main content */}
      <div className="flex-1 bg-[#FAF4EB] p-8">
        <header className="mb-8">
          <h1 className="text-2xl font-bold">Dashboard</h1>
          <p className="text-gray-600">Benvenuto nella tua area personale</p>
        </header>

        <div className="bg-white p-6 rounded-lg shadow-md col-span-1 md:col-span-2 lg:col-span-3">
        {/* Box Appuntamenti */}
          <div className="bg-white p-6 rounded-lg ">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold flex items-center">
                <Calendar className="w-5 h-5 mr-2 text-blue-600" />
                Prossimi Appuntamenti
              </h2>
              <button 
                onClick={() => navigate('/doctor/appointments')}
                className="text-sm text-purple-600 hover:underline"
              >
                Vedi tutti
              </button>
            </div>
            
            {loading ? (
              <p className="text-gray-500 text-center py-4">Caricamento...</p>
            ) : error ? (
              <p className="text-red-500 text-center py-4">{error}</p>
            ) : upcomingAppointments.length === 0 ? (
              <p className="text-gray-500 text-center py-4">Non hai appuntamenti programmati</p>
            ) : (
              <div className="space-y-4">
                {upcomingAppointments.map((appointment) => (
                  <div key={appointment.id} className="border-b pb-3 last:border-0 last:pb-0">
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="font-medium">
                          {appointment.patient_name && appointment.patient_name.trim() 
                            ? appointment.patient_name 
                            : `Paziente #${appointment.patient_id}`}
                        </p>
                        <p className="text-sm text-gray-600">{appointment.service_name}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-sm font-medium">{formatDate(appointment.date)}</p>
                        <p className="text-sm text-gray-600">{formatTime(appointment.time)}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            
            <div className="mt-4 pt-2 border-t">
              <button 
                onClick={() => navigate('/doctor/appointments')}
                className="w-full text-center py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
              >
                Gestisci Appuntamenti
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorDashboad;